<template>
  <span
    component-name="vector-icon"
    ref="tpl_root"
    class="[&>svg]:w-full [&>svg]:h-full [&>svg>*]:stroke-current"
    :class="{
      'w-3 h-3 min-w-3 min-h-3': size === 'tiny',
      'w-4 h-4 min-w-4 min-h-4': size === 'small',
      'w-6 h-6 min-w-6 min-h-6': size === 'regular',
      'w-8 h-8 min-w-8 min-h-8': size === 'big',
      'w-10 h-10 min-w-10 min-h-10': size === 'huge',
      'w-32 h-32 min-w-32 min-h-32': size === 'giant',
    }"
  >
    <svg
      v-if="icon === 'plus'"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5 8h6M8 5v6"
        :stroke-width="strokeWidth"
        stroke-linecap="round"
      />
      <circle cx="8" cy="8" r="7" :stroke-width="strokeWidth" />
    </svg>

    <svg
      v-else-if="icon === 'arrow-right'"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1 8.001h14M8.273 14.727 15 8 8.273 1.273"
        :stroke-width="strokeWidth"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>

    <svg
      v-else-if="icon === 'angle-dawn'"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.5 6.7 8 10.2l3.5-3.5"
        :stroke-width="strokeWidth"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>

    <svg
      v-else-if="icon === 'play'"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.5 5.332 10.65 8 6.5 10.668V5.332z"
        :stroke-width="strokeWidth"
      />
      <circle cx="8" cy="8" r="7" :stroke-width="strokeWidth" />
    </svg>
  </span>
</template>

<script setup>
import { useRootStore } from "@/stores/root";
const rootStore = useRootStore();

const props = defineProps({
  icon: {
    type: String,
    required: true,
    validator: function (value) {
      return (
        ["plus", "arrow-right", "angle-dawn", "play"].indexOf(value) !== -1
      );
    },
  },
  size: {
    type: String,
    required: false,
    validator: function (value) {
      return (
        ["tiny", "small", "regular", "big", "huge", "giant"].indexOf(value) !==
        -1
      );
    },
  },
});

const tpl_root = templateRef("tpl_root");
const strokeWidth = computed(() => {
  let w;
  switch (rootStore.brand) {
    case "bebitalia":
      w = 2;
      break;

    case "maxalto":
      w = 1.5;
    default:
      break;
  }

  return w;
});

onMounted(() => {
  let elements = tpl_root.value.querySelectorAll("svg > *");

  elements.forEach((current) => {
    current.setAttribute("vector-effect", "non-scaling-stroke");
  });
});
</script>
